import { IconographyTypes } from '@genial/icons';
import { IndexerResponseFilter } from '@genial/services/dist/models';

import { captionsIconMapping } from '../constants';
import { DynamicCustomFilterProps, DynamicProductCaptionsGetter } from '../types';

export const normalizeCustomFilter = (
  fieldName: string,
  label: string,
  options?: IndexerResponseFilter[] | null
) => {
  return {
    fieldName,
    label,
    options: (options || []).map((option) => ({
      label: option.label || '',
      value: option.value || '',
    })),
  } as DynamicCustomFilterProps;
};

export const filterHasOptions = (filter: DynamicCustomFilterProps) => filter.options.length > 0;

export const getProductCaptions = (
  fullObject: DynamicProductCaptionsGetter
): IconographyTypes.Option[] => {
  const result: IconographyTypes.Option[] = [];

  for (const key in captionsIconMapping) {
    if (fullObject[key]) {
      result.push(captionsIconMapping[key]);
    }
  }

  return result;
};

export * from './directTreasury';
export * from './fixedIncome';
export * from './funds';
export * from './equity';
export * from './publicOffer';
export * from './clubs';
export * from './privatePension';
